import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { Box, Grid, useMediaQuery } from '@material-ui/core';
import { useTheme } from '@material-ui/core/styles';

import { Button, LoadMoreButton } from 'evee-ui-common/components/base';
import DefaultDialog from 'widgets/layout/DefaultDialog';
import Review from 'widgets/profile/Review';
import useLoadMoreCounter from 'common/hooks/useLoadMoreCounter';

const Reviews = ({ reviews }) => {
  const theme = useTheme();
  const isTabletOrMobile = useMediaQuery(theme.breakpoints.down('md'));
  const [visibleItemsCount, showMoreItems] = useLoadMoreCounter(10, reviews.length);
  const [allReviewsOpen, setAllReviewsOpen] = useState(false);

  const dialogReviewsJsx = reviews.slice(0, visibleItemsCount).map((review, i) => (
    <React.Fragment key={i}>
      <Grid item xs={12}>
        <Review key={i} review={review} />
      </Grid>
    </React.Fragment>
  ));

  const allReviewsDialogJsx = (
    <DefaultDialog
      fullScreen={isTabletOrMobile}
      open={allReviewsOpen}
      title="Reviews"
      onClose={() => setAllReviewsOpen(false)}
    >
      <Box padding="8px">
        <Grid container spacing={2} justifyContent="center">
          {dialogReviewsJsx}
        </Grid>
        {visibleItemsCount < reviews.length && (
          <LoadMoreButton style={{ width: '150px' }} onClick={showMoreItems} />
        )}
      </Box>
    </DefaultDialog>
  );

  return (
    <Box display="flex" flexDirection="column" paddingTop="24px">
      {reviews.slice(0, 2).map((review, i) => (
        <Review key={i} review={review} />
      ))}

      {reviews.length > 2 && (
        <Box width="100%" display="flex" justifyContent="flex-start" marginBottom="56px">
          <Button
            disableRipple
            type="outlined"
            size="large"
            color="primary"
            text={`Show all ${reviews.length} reviews`}
            onClick={() => setAllReviewsOpen(true)}
          />
        </Box>
      )}

      {allReviewsDialogJsx}
    </Box>
  );
};

Reviews.propTypes = {
  reviews: PropTypes.arrayOf(
    PropTypes.shape({
      photo: PropTypes.string,
      name: PropTypes.string,
      nickname: PropTypes.string,
      rating: PropTypes.number,
      text: PropTypes.string,
      date: PropTypes.string,
    }),
  ),
};

Reviews.defaultProps = {
  reviews: [],
};

export default Reviews;
